import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=e24998c4&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=e24998c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24998c4",
  null
  
)

export default component.exports